import Vue from 'vue'

Vue.directive('focus', {
  inserted: function(el, binding) {
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') {
      el.focus()
    } else {
      el = el.querySelector('input, textarea, select')
      if (el) {
        el.focus()
      }
    }
  }
})
